import angular from 'angular'

import securityDepositSummary from './securityDepositSummary'
import securityDepositCancelModal from './modal/securityDepositCancelModal'
import securityDepositFAQModal from './modal/securityDepositFAQModal'
import securityDepositPostponeModal from './modal/securityDepositPostponeModal'

/* Angular styleguide Modularity - https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#modularity */
export default angular
.module('unergie.securityDepositSummary', [])
.component('securityDepositSummary', securityDepositSummary)
.component('securityDepositCancelModal', securityDepositCancelModal)
.component('securityDepositFAQModal', securityDepositFAQModal)
.component('securityDepositPostponeModal', securityDepositPostponeModal)
.name



// WEBPACK FOOTER //
// ./src/states/securityDepositSummary/securityDepositSummary.module.js